<template>
  <div>
    <div class="header flex-between">
      <div class="header-text">
        <h1>券包管理</h1>
      </div>
      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="el-icon-search"
          @click="query"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.create"
          icon="el-icon-notebook-2"
          @click="goToVoucherCreate"
          >创建</el-button
        >
        <el-button
          v-if="jurisdiction.copy"
          icon="el-icon-edit-outline"
          @click="VolumeCopy"
          >复制</el-button
        >
        <el-button
          v-if="jurisdiction.state"
          icon="el-icon-edit-outline"
          @click="StateChange"
          >启用/禁用</el-button
        >
        <el-button
          v-if="jurisdiction.modify"
          icon="el-icon-edit-outline"
          @click="ViewUpdate"
          >修改</el-button
        >
        <el-button
          v-if="jurisdiction.delete"
          icon="el-icon-edit-outline"
          @click="Delete"
          >删除</el-button
        >
        <el-button
          v-if="jurisdiction.look"
          icon="el-icon-edit-outline"
          @click="see"
          >查看</el-button
        >
      </div>
    </div>
    <el-card shadow="never">
      <el-form :model="page" size="small" label-width="80px">
        <el-row :gutter="100">
          <el-col :span="8">
            <el-form-item label="券包名称">
              <el-input v-model="page.coupPacketName" placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card shadow="never" style="margin-top: 10px">
      <el-table
        class="table-style"
        border
        :height="PagesIsMore ? 'calc(100vh - 22.5rem)' : 'calc(100vh - 22rem)'"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          color: '#6C6839',
          'text-align': 'center',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="RollbagList"
        tooltip-effect="dark"
        @select="dialogCheck"
        @selection-change="handleSelectionChange"
        v-el-table-infinite-scroll="PageTouchTheBottom"
        infinite-scroll-disabled="infiniteScrollDisabledIs"
        v-loading="page.Loading"
      >
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column label="券库名称">
          <template slot-scope="scope">
            <div v-if="jurisdiction.look" class="ConponesName" @click="OnclickConponesName(scope.row)">
              {{ scope.row.coupPacketName }}
            </div>
            <div v-else class="ConponesName">
              {{ scope.row.coupPacketName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="stateText" label="状态"> </el-table-column>
        <el-table-column prop="createUserName" label="创始人">
        </el-table-column>
        <el-table-column prop="createTimeStr" label="创建日期">
        </el-table-column>
        <el-table-column prop="updateUserName" label="最后修改人">
        </el-table-column>
        <el-table-column prop="updateTimeStr" label="最后修改日期">
        </el-table-column>
      </el-table>
      <el-alert
        v-if="PagesIsMore"
        title="没有更多数据了!"
        type="warning"
        center
        :closable="false"
      >
      </el-alert>
    </el-card>
  </div>
</template>

<script>
import { couppacketList, couppacketdelete } from "@/api/couponsDepot.js";
export default {
  name: "centre",
  data() {
    return {
      jurisdiction:{
        search:false,
        create:false,
        copy:false,
        state:false,
        modify:false,
        delete:false,
        look:false,
      },
      labelPosition: "right",
      SelectChang: {}, //选择的行
      page: {
        //列表请求参数
        pageNo: 1,
        pageSize: 50,
        pages: 1,
        Loading: true,
        coupPacketName: "",
      },
      RollbagList: [],
    };
  },
  computed: {
    PagesIsMore() {
      return this.page.pageNo >= this.page.pages;
    },
    infiniteScrollDisabledIs() {
      return this.page.Loading || this.PagesIsMore;
    },
  },
  created() {
    this.RcouppacketList();
    let Coupon = JSON.parse(localStorage.getItem("Coupon"));
    for (let i = 0; i < Coupon.length; i++) {
      if (Coupon[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (Coupon[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }
      if (Coupon[i].menuName == "复制") {
        this.jurisdiction.copy = true;
        continue;
      }
      if (Coupon[i].menuName == "启用/禁用") {
        this.jurisdiction.state = true;
        continue;
      }
      if (Coupon[i].menuName == "修改") {
        this.jurisdiction.modify = true;
        continue;
      }
      if (Coupon[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }
      if (Coupon[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
    }
    console.log(Coupon);
  },
  methods: {
    OnclickConponesName(row) {
      this.SelectChang = row;
      this.see();
    },
    Delete() {
      if (Object.keys(this.SelectChang).length <= 2) {
        this.$message({
          message: "请先选择数据,才能进行状态删除!",
          type: "warning",
        });
        return false;
      }
      this.$confirm("此操作将永久删除该条信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = require("qs").stringify({
            coupPacketID: this.SelectChang.coupPacketID,
          });
          couppacketdelete(data).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.page.pageNo = 1;
              this.page.Loading = true;
              this.RollbagList = [];
              this.RcouppacketList();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    StateChange() {
      if (Object.keys(this.SelectChang).length <= 2) {
        this.$message({
          message: "请先选择数据,才能进行状态修改!",
          type: "warning",
        });
        return false;
      }
      this.$store.dispatch("user/USetCouponsSelectChang", this.SelectChang);
      localStorage.setItem(
        "CouponsSelectChang",
        JSON.stringify(this.SelectChang)
      );
      this.$router.push("/VoucherdisableEnable");
    },
    ViewUpdate() {
      if (Object.keys(this.SelectChang).length <= 2) {
        this.$message({
          message: "请先选择数据,才能进行修改!",
          type: "warning",
        });
        return false;
      }
      this.$store.dispatch("user/USetCouponsSelectChang", this.SelectChang);
      localStorage.setItem(
        "CouponsSelectChang",
        JSON.stringify(this.SelectChang)
      );
      this.$router.push("/VoucherUpdate");
    },
    VolumeCopy() {
      if (Object.keys(this.SelectChang).length <= 2) {
        this.$message({
          message: "请先选择数据,才能进行复制!",
          type: "warning",
        });
        return false;
      }
      this.$store.dispatch("user/USetCouponsSelectChang", this.SelectChang);
      localStorage.setItem(
        "CouponsSelectChang",
        JSON.stringify(this.SelectChang)
      );
      this.$router.push("/VoucherCopy");
    },
    see() {
      if (Object.keys(this.SelectChang).length <= 2) {
        this.$message({
          message: "请先选择数据,才能进行查看!",
          type: "warning",
        });
        return false;
      }
      this.$store.dispatch("user/USetCouponsSelectChang", this.SelectChang);
      localStorage.setItem(
        "CouponsSelectChang",
        JSON.stringify(this.SelectChang)
      );
      this.$router.push("/VoucherSee");
    },
    query() {
      this.page.pageNo = 1;
      this.page.Loading = true;
      this.RollbagList = [];
      this.RcouppacketList();
    },
    PageTouchTheBottom() {
      this.page.Loading = true;
      this.page.pageNo++;
      this.RcouppacketList();
    },
    dialogCheck(selection, row) {
      this.$refs.multipleTable.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.SelectChang = row;
        this.$refs.multipleTable.toggleRowSelection(row, true);
      }
    },
    handleSelectionChange(e) {
      if (e.length > 0) {
        this.SelectChang = e[e.length - 1];
      } else {
        this.SelectChang = {};
      }
    },
    returnStateText(type) {
      let text = "";
      switch (type) {
        case 0:
          text = "已启用";
          break;
        case 1:
          text = "未启用";
          break;
        case 2:
          text = "已禁用";
          break;
      }
      return text;
    },
    RcouppacketList() {
      let data = require("qs").stringify({
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        coupPacketName: this.page.coupPacketName,
      });
      couppacketList(data).then((res) => {
        if (res.success) {
          this.page.pages = res.data.pages;
          res.data.list.forEach((item) => {
            item.stateText = this.returnStateText(parseInt(item.state));
          });
          this.RollbagList = this.RollbagList.concat(res.data.list);
        } else {
          this.$message.error(res.message);
        }
        this.page.Loading = false;
      });
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    goToVoucherCreate() {
      this.$router.push("/VoucherCreate");
    },
  },
};
</script>
<style lang="scss" scoped>
.ConponesName {
  text-decoration: underline;
  color: #a19b59;
}
.ConponesName:hover {
  cursor: pointer;
}
.header-text {
  height: 50px;
  line-height: 50px;
  color: #76734f;
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }
  .el-table .success-row {
    background: #ffffff;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
}
</style>
